import { apiService } from "../apiService";
import urlConfig from "../../config/domain";
import loginURLConfig from "../../config/login/loginURLConfig";

export const etotpSendOtp = ( callback: CallableFunction, usrId: string, accTyp: string ) => {
    apiService(
        {
          url: loginURLConfig.etotpBaseUrl + "send/otp/" + usrId + "?acTyp=" +accTyp,
          method: "GET",
          authType: "authtoken",
          appidkey: urlConfig.appidkey,
        },
        callback
      );
};

export const ValidateEtotpOtp = ( callback: CallableFunction, body:any ) => {
    apiService(
        {
          url: loginURLConfig.etotpBaseUrl + "validate/otp",
          method: "POST",
          authType: "authtoken",
          appidkey: urlConfig.appidkey,
          body,
        },
        callback
      );
};

export const generateSecretkey = ( callback: CallableFunction, body:any ) => {
    apiService(
        {
          url: loginURLConfig.etotpBaseUrl + "generate/secretkey",
          method: "POST",
          authType: "authtoken",
          appidkey: urlConfig.appidkey,
          body,
        },
        callback
      );
};

export const validateSecretkey = ( callback: CallableFunction, body:any ) => {
    apiService(
        {
          url: loginURLConfig.etotpBaseUrl + "validate/secretkey",
          method: "POST",
          authType: "authtoken",
          appidkey: urlConfig.appidkey,
          body,
        },
        callback
      );
};

export const disableEtotp = ( callback: CallableFunction, body:any ) => {
    apiService(
        {
          url: loginURLConfig.etotpBaseUrl + "disable",
          method: "POST",
          authType: "authtoken",
          appidkey: urlConfig.appidkey,
          body,
        },
        callback
      );
};
export const validatePassword = ( callback: CallableFunction, usrId: string, pwd: string ) => {
  apiService(
      {
        url: loginURLConfig.account + "validateuidpwd/" + usrId,
        method: "POST",
        authType: "authtoken",
        appidkey: urlConfig.appidkey,
        body:{ pwd },
      },
      callback
    );
};
